//src/components/ImportDataList/CardwithDropdown.js
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Card,
  CardContent,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Snackbar,
  Alert,
  Button,
  Menu
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ImportExcelModal from "./ImportExcelModal";
import { clearImportData } from "../../redux/donorSlice";
import {
  uploadPrasadFile,
  uploadStatusFile, uploadLocationFile,
} from "../../redux/importDataSlice";
import { logger } from "../../utils/logger";

const CardwithDropdown = () => {
  const [expanded, setExpanded] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [file, setFile] = useState(null);
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const [feedback, setFeedback] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const handleCardClick = () => {
    setExpanded((prev) => !prev);
  };

  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedOption(value);
    // setExpanded(false);
    // setModalOpen(true); 
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    logger.info(`File selected: ${selectedFile.name}`, {
      page: "Import Data",
      username: user?.username,
      role: user?.role,
      file: selectedFile.name,
    });
  };

  const handleSubmit = async () => {
    if (!file) {
      logger.warn("Submitted before selecting the file", {
        page: "Import Data",
        username: user?.username,
        role: user?.role,
      });
      setFeedback({
        open: true,
        message: "Please select a file before importing",
        severity: "warning",
      });
      return;
    }
    dispatch(clearImportData());
    try {
      switch (selectedOption) {
        case "prasad":
          const resultPrasad = await dispatch(uploadPrasadFile(file)).unwrap();
          if (resultPrasad.success) {
            logger.info("Prasad Yes file imported successfully", {
              page: "Import Data",
              username: user?.username,
              role: user?.role,
            });
            setFeedback({
              open: true,
              message:
                String(resultPrasad.message) ||
                "Prasad statuses updated successfully.",
              severity: "success",
            });
          }
          if (
            resultPrasad.missingDonors &&
            resultPrasad.missingDonors.length > 0
          ) {
            logger.warn("Some donor IDs were not found", {
              page: "Import Data",
              Ids: resultPrasad?.missingDonors,
              username: user?.username,
              role: user?.role,
            });
            setFeedback({
              open: true,
              message: `Some donor IDs were not found: ${resultPrasad.missingDonors.join(
                ", "
              )}`,
              severity: "warning",
            });
          }
          break;
        case "status":
          const resultStatus = await dispatch(uploadStatusFile(file)).unwrap();
          if (resultStatus.success) {
            logger.info("Status file imported successfully", {
              page: "Import Data",
              username: user?.username,
              role: user?.role,
            });
            setFeedback({
              open: true,
              message:
                String(resultStatus.message) ||
                "Statuses updated successfully.",
              severity: "success",
            });
          }
          if (
            resultStatus.missingDonors &&
            resultStatus.missingDonors.length > 0
          ) {
            logger.warn("Some donor IDs were not found", {
              Ids: resultStatus?.missingDonors,
              username: user?.username,
              role: user?.role,
            });
            setFeedback({
              open: true,
              message: `Some donor IDs were not found: ${resultStatus.missingDonors.join(
                ", "
              )}`,
              severity: "warning",
            });
          }
          if (
            resultStatus.invalidStatuses &&
            resultStatus.invalidStatuses.length > 0
          ) {
            logger.warn("Some invalid statuses were found", {
              page: "Import Data",
              invalidStatuses: resultStatus?.invalidStatuses,
              username: user?.username,
              role: user?.role,
            });
            setFeedback({
              open: true,
              message: `Some invalid statuses were found for donor IDs: ${resultStatus.invalidStatuses
                .map((item) => `${item.donorId} (${item.status})`)
                .join(", ")}`,
              severity: "warning",
            });
          }
          break;
        case "location":
          const resultLocation = await dispatch(
            uploadLocationFile(file)
          ).unwrap();
          if (resultLocation.success) {
            logger.info("Location file imported successfully", {
              page: "Import Data",
              username: user?.username,
              role: user?.role,
            });
            setFeedback({
              open: true,
              message:
                String(resultLocation.message) ||
                "Locations updated successfully.",
              severity: "success",
            });
          }
          if (
            resultLocation.missingDonors &&
            resultLocation.missingDonors.length > 0
          ) {
            logger.warn("Some donor IDs were not found", {
              Ids: resultLocation?.missingDonors,
              username: user?.username,
              role: user?.role,
            });
            setFeedback({
              open: true,
              message: `Some donor IDs were not found: ${resultLocation.missingDonors.join(
                ", "
              )}`,
              severity: "warning",
            });
          }
          if (
            resultLocation.incompleteRows &&
            resultLocation.incompleteRows.length > 0
          ) {
            logger.warn("Some rows were incomplete", {
              page: "Import Data",
              incompleteRows: resultLocation?.incompleteRows,
              username: user?.username,
              role: user?.role,
            });
            setFeedback({
              open: true,
              message: `Some rows were incomplete and skipped.`,
              severity: "warning",
            });
          }

          break;
        default:
          return;
      }

      setModalOpen(false);
      setFile(null);
      setSelectedOption("");
      setExpanded(false);
    } catch (err) {
      logger.error("Error during excel import", {
        page: "Import Data",
        username: user?.username,
        role: user?.role,
        error: err,
      });
      setFeedback({
        open: true,
        message:
          err?.message || String(err) || "An error occurred, Please try again.",
        severity: "error",
      });
    }
  };

  const handleCloseFeedback = () => {
    setFeedback({ ...feedback, open: false });
  };

  return (
    <>
          <Card
        sx={{
          width: 220,
          height: 200,
          textAlign: "center",
          p: 2,
          boxShadow: 3,
          borderRadius: 2,
          "&:hover": { boxShadow: 6, backgroundColor: "#f5f5f5" },
        }}
      >
        <CardContent sx={{ padding: "5px" }}>
          <CloudUploadIcon sx={{ fontSize: 40, color: "#1976d2" }} />
          <Typography
            variant="h6"
            sx={{
              fontSize: "0.9rem",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            Update Details
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontSize: "0.68rem",
              whiteSpace: "pre-wrap",
              textOverflow: "ellipsis",
              mb: 1,
            }}
          >
            Choose an update type and import the Excel file.
          </Typography>

    
            <FormControl fullWidth size="small">
              <InputLabel>Choose Option</InputLabel>
              <Select
                value={selectedOption}
                label="Choose Option"
                onChange={handleChange}
              >
                <MenuItem value="prasad">Update Prasad</MenuItem>
                <MenuItem value="status">Update Status</MenuItem>
                <MenuItem value="location">Update Location</MenuItem>
                <MenuItem value="">Select</MenuItem>
              </Select>
            </FormControl>
   <Button
            variant="contained"
            color="primary"
            size="small"
            sx={{ mt: 2 }}
            disabled={!selectedOption}
            onClick={() => setModalOpen(true)}
          >
            Import
          </Button>
        </CardContent>
      </Card>

      <ImportExcelModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onFileChange={handleFileChange}
        onSubmit={handleSubmit}
        title={
          selectedOption === "prasad"
            ? "Upload Prasad Excel"
            : selectedOption === "status"
            ? "Upload Status Excel"
            : selectedOption === "location"
            ? "Upload Location Excel"
            : "Upload Excel File"
        }
      />

      {/* Snackbar to display feedback message */}
      <Snackbar
        open={feedback.open}
        autoHideDuration={4000}
        onClose={handleCloseFeedback}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseFeedback}
          severity={feedback.severity}
          sx={{ width: "100%" }}
        >
          {typeof feedback.message === "string"
            ? feedback.message
            : JSON.stringify(feedback.message)}
        </Alert>
      </Snackbar>
    </>
  );
};

export default CardwithDropdown;
